import { useSelector } from "react-redux";
import State from "../../state/vo/State";

export default function useCustomerId(): string | undefined {
  return useSelector((state: State) => state.account.customer?.id);
}
